// extracted by mini-css-extract-plugin
module.exports = {"message":"MessagesBell_message__8dRmu"};